import { DefaultBreakpoints } from '../defaults/breakpoints'

type BreakpointKey = keyof typeof DefaultBreakpoints

// Note: plain strings, not theme-driven - breakpoints are the same across every white-label
// theme (chitowntrainer/elevatedliving), so these don't need ThemeProvider context to use,
// unlike color/spacing tokens. Usage:
//   css`
//     display: block;
//
//     ${media.up('md')} {
//       display: flex;
//     }
//   `
export const media = {
  down: (breakpoint: BreakpointKey) =>
    `@media (max-width: ${DefaultBreakpoints[breakpoint] - 1}px)`,
  up: (breakpoint: BreakpointKey) => `@media (min-width: ${DefaultBreakpoints[breakpoint]}px)`,
}
